import React from 'react';
import styles from "./add-edit-product.scss";
import ToggleBtnGroup from "jd-library/ToggleBtnGroup";

const ServiceSwitch = ({
    showSellOnline, productData, selectedType, isVariant, toggleChangeModal, updateType
    , variantProps, updateRemovedSpec, addRemoveSpecVariant, toggleVariantWelcome, hasVariantSpec, isMobile, isService }) => {

    return (
        <div
            className={`${styles["marginLR15"]} ${styles["marginT16"]} ${styles["display-price-qty"]
                } ${showSellOnline ? styles["marginB15"] : styles["marginB15"]} ${productData.productId != "ADD_PRODUCT"
                    ? styles["display-price-qty-no-border"]
                    : ""
                }`}
        >
            <div className={"display-price-qty-title"}>
                {`Select ${selectedType == 'product' ? 'Product' : 'Service'} Type`}
            </div>
            <ToggleBtnGroup
                selectedValue={isVariant}
                disabled={
                    isVariant && productData.productId != "ADD_PRODUCT"
                        ? true
                        : false
                }
                onToggle={(e, value) => {
                    if(!(isVariant && productData.productId != "ADD_PRODUCT")) {
                        if (!value) {
                            toggleChangeModal({ key: "product" , isService: isService});
                            return;
                        }
                        value != isVariant && updateType(value);
                        if (value && !variantProps.variantProductData.length) {
                            updateRemovedSpec(
                                addRemoveSpecVariant({ remove: true })
                            );
                            toggleVariantWelcome(true);
                        }
                    }
                }}
            >
                <ToggleBtnGroup.Btn
                    className={`${styles["input-grp-btn"]} ${isVariant && productData.productId != "ADD_PRODUCT"
                        ? styles["input-disabled-btn"]
                        : ""
                        }`}
                    value={0}
                    disabled={
                        hasVariantSpec &&
                        isVariant &&
                        productData.productId != "ADD_PRODUCT"
                    }
                >
                    <div className={"title-txt"}>
                        <span>{`SINGLE ${selectedType == 'product' ? 'PRODUCT' : 'SERVICE'}`}</span>
                    </div>
                </ToggleBtnGroup.Btn>
                <ToggleBtnGroup.Btn
                    className={styles["input-grp-btn"]}
                    value={1}
                    disabled={!isVariant && productData.productId != "ADD_PRODUCT"}
                >
                    <div className={"title-txt"}>
                        <span>MULTIPLE VARIANT</span>
                    </div>
                </ToggleBtnGroup.Btn>
            </ToggleBtnGroup>
            <div className={`display-price-qty-title info-txt ${isMobile ? "mobile" : ""}`}>
                <i
                    className={"icon-alert_outline"}
                    style={{ marginRight: "5px" }}
                />
                <span>{`Please Note that ${selectedType == 'product' ? 'Product' : 'Service'} Type Cannot be Changed Later`}</span>
            </div>
        </div>
    )
}

export default ServiceSwitch